import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { HolidayValidationSchema } from "../schemas/create.schema";

interface UseUpdateHolidayProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateHoliday = ({id, onSuccess, onError}: UseUpdateHolidayProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateHoliday'],
    mutationFn: async (form: HolidayValidationSchema) => {
      const { geo, ...rest } = form

      const holiday = {
        ...rest,
        geo_type: geo.type,
        geo_id: geo.value
      }

      return privateAxios.put(`/calendar/holidays/${id}`, { holiday })
    },
    onSuccess,
    onError
  });
}

export default useUpdateHoliday
